import React, { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PrivateRouteProps {
  children: ReactNode;
  requireAppAccess?: boolean;
}

export function PrivateRoute({ children, requireAppAccess = false }: PrivateRouteProps) {
  const { currentUser, loading, canAccessApp } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!currentUser) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?redirect=${redirect}`} replace />;
  }

  if (requireAppAccess && !canAccessApp) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
